import React, { useState } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    TextField,
    Button,
    TableContainer,
    Grid,
} from "@material-ui/core";
import { useStyles, StyledTableCell } from "../../adminStyles";

import ExcelExport from "./ExportExcel";

const VacationHourTable = props => {
    const [searchTerm, setSearchTerm] = useState("");
    const {
        tableRoot,
        sortLabel,
        approveBtn,
        tableContainer,
        gridElRight,
        gridElLeft,
        btnMobile,
        inputMobile,
    } = useStyles();

    const { columns, rows, sortArray, orderAscending, orderBy, asc } = props;

    const setTheSearchTerm = e => {
        setSearchTerm(e.target.value);
    };
    const userTableProps = {
        columns,
        rows,
        sortArray,
        orderAscending,
        asc,
        ...props,
    };
    const renderStyledTableCell = () =>
        columns.map(column =>
            column.id === "empId" ||
            column.id === "empName" ||
            column.id === "vacationHrs" ||
            column.id === "sickHrs" ||
            column.id === "holidayHrs" ? (
                <StyledTableCell
                    key={column.id}
                    align={"center"}
                    padding={column.disablePadding ? "none" : "default"}
                    sortDirection={
                        orderBy === column.id ? orderAscending : false
                    }
                >
                    <TableSortLabel
                        active={orderBy === column.id}
                        direction={asc}
                        onClick={sortArray(rows, column.id)}
                        className={sortLabel}
                    >
                        {column.label}
                    </TableSortLabel>
                </StyledTableCell>
            ) : (
                <StyledTableCell
                    key={column.id}
                    align={"center"}
                    padding={column.disablePadding ? "none" : "default"}
                >
                    {column.label}
                </StyledTableCell>
            )
        );

    const renderTableBody = () =>
        rows
            .filter(
                row =>
                    (row.empId || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.empName || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.vacationHrs + "" || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.sickHrs + "" || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.holidayHrs + "" || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
            )
            .map((row, i) => {
                return (
                    <TableRow tabIndex={-1} key={row.code}>
                        {columns.map(column => {
                            const value = row[column.id];

                            return (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    width={column.mainWidth}
                                >
                                    {column.id === "empId" ? value : null}
                                    {column.id === "empName" ? value : null}
                                    {column.id === "vacationHrs" ? value : null}
                                    {column.id === "sickHrs" ? value : null}
                                    {column.id === "holidayHrs" ? value : null}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                );
            });

    return (
        <>
            <Grid container justify="center" alignItems="center">
                <Grid item xs={12} md={6} className={gridElLeft}>
                    <TextField
                        type="search"
                        label="Search"
                        className={inputMobile}
                        variant="outlined"
                        value={searchTerm}
                        onChange={setTheSearchTerm}
                    />
                </Grid>
                <Grid xs={12} md={6} className={gridElRight}>
                    <ExcelExport approveBtn={approveBtn} {...userTableProps} />
                    {props.showUploadButton ? (
                        <Button
                            className={btnMobile}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                props.gotoUpload();
                            }}
                        >
                            Upload Hours
                        </Button>
                    ) : null}
                </Grid>
            </Grid>
            <Paper className={tableRoot}>
                <TableContainer className={tableContainer}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>{renderStyledTableCell()}</TableRow>
                        </TableHead>
                        <TableBody>{renderTableBody()}</TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    );
};

export default VacationHourTable;
